module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@2x-b059d26b35985ea424e953d7384f6495.png";